import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	title: {
		marginBottom: theme.spacing(4),
		textAlign: 'center'
	},
	progressbar: {
		paddingTop: theme.spacing(12),
		'& .MuiLinearProgress-colorPrimary': {
			backgroundColor: 'rgb(245,129,52,0.3)'
		},
		'& .MuiLinearProgress-barColorPrimary': {
			backgroundColor: 'rgb(245,129,52)'
		}
	}
}));
